import { Position } from './position';
import { Coords } from './coords';

export class Polyline {
    id: string;
    data: string;
    name: string;
    startpoint: any;
    endpoint: any;
    waypoints: any[];
    strokeColor: string;

    constructor();
    constructor(json: any);
    constructor(idOrjson: any, name: string, data: string, startpoint: any, endpoint: any, waypoints: any[], strokeColor: string);
    constructor(idOrjson?: any, name?: string, data?: string, startpoint?: any, endpoint?: any, waypoints?: any[], strokeColor?: string) {
        if (idOrjson) {
            if (name) {
                this.id = idOrjson;
                this.name = name;
                this.data = data;
                this.startpoint = startpoint;
                this.endpoint = endpoint;
                this.waypoints = waypoints;
                this.strokeColor = strokeColor;
            } else {
                this.id = idOrjson.id;
                this.name = idOrjson.name;
                this.data = idOrjson.data;
                this.startpoint = idOrjson.startpoint;
                this.endpoint = idOrjson.endpoint;
                this.waypoints = idOrjson.waypoints;
                this.strokeColor = idOrjson.strokeColor;
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/polyline.ts